import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import getBreakpoint from 'utils/getBreakpoint';
import rootReducer from './rootReducer';
import { updateBreakpoint } from './global/globalActions';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// @ts-ignore
const store = createStore(
    rootReducer, /* preloadedState, */
    composeEnhancers(
        applyMiddleware(thunk, promiseMiddleware())
    )
);


window.addEventListener('resize', () => {
    const prevBreakpoint = store.getState().global.breakpoint;
    const currBreakpoint = getBreakpoint();
    if (prevBreakpoint !== currBreakpoint) {
        store.dispatch(updateBreakpoint(currBreakpoint));
    }
});

export default store;
